var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.isSuccess
      ? _c(
          "div",
          {
            staticClass: "signup-container",
            class: { standalone: !_vm.inSlider },
            attrs: { id: _vm.formId },
            on: {
              keyup: function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.submit($event)
              }
            }
          },
          [
            !_vm.inPathDD
              ? _c("frontier-miles-info", { attrs: { cdnHost: _vm.cdnHost } })
              : _c("dd-info", {
                  attrs: {
                    host: _vm.host,
                    imageRelativePath: _vm.imageRelativePath,
                    inSlider: _vm.inSlider,
                    discountAmount: this.discountAmount,
                    enrollmentFeeAmount: this.enrollmentFeeAmount,
                    signupFeeAmount: this.signupFeeAmount,
                    totalAmount: this.totalAmount,
                    discountedEnrollmentFeeAmount: this
                      .discountedEnrollmentFeeAmount
                  }
                }),
            _vm._v(" "),
            _vm.inPathDD
              ? _c("div", { staticClass: "login-section" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "login-form-section" },
                    [
                      _c("div", { staticClass: "login-form-header" }, [
                        _vm._v(
                          "\n                    Log In Now!\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("login", {
                        attrs: {
                          inPathDD: _vm.inPathDD,
                          "reload-on-login": true,
                          "show-signup": false,
                          "has-gray-background": false
                        },
                        on: {
                          "login-success": function($event) {
                            _vm.changed = false
                          },
                          change: function($event) {
                            _vm.changed = true
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("error-list", {
              ref: "errorList",
              attrs: {
                messages: _vm.errors.items,
                "top-rules": ["age_restriction"]
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "signup-legend text-small" }, [
              _vm._v("\n            *Required Fields\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "signup-info-header" }, [
              _c("div", { staticClass: "signup-header-text" }, [
                _c("span", [_vm._v(_vm._s(_vm.formTitle))])
              ])
            ]),
            _vm._v(" "),
            _c("signup-fields", {
              ref: "fields",
              attrs: {
                "validation-scope": _vm.validationScope,
                isDDSignup: _vm.inPathDD
              },
              on: {
                change: function($event) {
                  _vm.changed = true
                }
              },
              model: {
                value: _vm.customer,
                callback: function($$v) {
                  _vm.customer = $$v
                },
                expression: "customer"
              }
            }),
            _vm._v(" "),
            _c(
              "f9button",
              {
                ref: "submitButton",
                staticClass: "submit-button",
                attrs: { disabled: !_vm.changed, loading: _vm.submitting },
                on: { click: _vm.submit }
              },
              [_vm._v("\n            JOIN NOW\n        ")]
            )
          ],
          1
        )
      : _c(
          "div",
          {
            staticClass: "signup-container",
            class: { standalone: !_vm.inSlider }
          },
          [
            _c(
              "div",
              { staticClass: "signup-frontiermiles-logo success-state-logo" },
              [_vm._v("THANK YOU FOR SIGNING UP!")]
            ),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c(
              "f9button",
              {
                ref: "submitButton",
                staticClass: "submit-button view-profile-button",
                on: { click: _vm.viewProfile }
              },
              [_vm._v("\n            VIEW PROFILE\n        ")]
            ),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "signup-info signup-images" }, [
              _c("div", { staticClass: "signup-image" }, [
                _c("img", {
                  attrs: {
                    src:
                      _vm.host + _vm.imageRelativePath + "icon_mileformile.svg",
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _vm._m(3)
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "signup-image" }, [
                _c("img", {
                  attrs: {
                    src:
                      _vm.host + _vm.imageRelativePath + "icon_swipeearn.svg",
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "signup-images-text-container" }, [
                  _c("span", { staticClass: "signup-images-large-text" }, [
                    _vm._v("Swipe. Earn.")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "signup-images-small-text" }, [
                    _vm._v(
                      "Unlock status, miles & family pooling with the FRONTIER Airlines World Mastercard."
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: this.barclaysFrontierMilesSignupLink,
                        target: "_blank",
                        rel: "noopener"
                      }
                    },
                    [_vm._v("LEARN MORE")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "signup-image" }, [
                _c("img", {
                  attrs: {
                    src:
                      _vm.host + _vm.imageRelativePath + "icon_getstatus.svg",
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _vm._m(4)
              ])
            ])
          ],
          1
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login-info-header" }, [
      _c("div", [_vm._v("Already have a ")]),
      _vm._v(" "),
      _c("div", { staticClass: "Frontier" }, [_vm._v("FRONTIER MILES")]),
      _vm._v(" "),
      _c("span", { staticClass: "sm" }, [_vm._v("℠")]),
      _vm._v(" "),
      _c("div", [_vm._v(" account?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "signup-p" }, [
      _vm._v(
        "\n            You are now a member! You will receive an email with your membership information. You can also go to your \n            "
      ),
      _c("span", { staticClass: "success-italic" }, [_vm._v("FRONTIER")]),
      _vm._v(
        " \n            profile to view your account, manage your preferences, and track your miles.\n        "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "signup-info-header green-cyan-gradient" },
      [
        _c("div", { staticClass: "ibe-text-like-h5" }, [
          _c("strong", [_vm._v("ABOUT")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "signup-images-text-container" }, [
      _c("span", { staticClass: "signup-images-large-text" }, [
        _vm._v("Mile for Miles")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "signup-images-small-text" }, [
        _vm._v(
          "Earn 1 point for each mile flown. It's easy to earn & use your FRONTIER Miles."
        )
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.flyfrontier.com/frontiermiles/how-to-earn-miles",
            target: "_blank",
            rel: "noopener"
          }
        },
        [_vm._v("LEARN MORE")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "signup-images-text-container" }, [
      _c("span", { staticClass: "signup-images-large-text" }, [
        _vm._v("Get Status")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "signup-images-small-text" }, [
        _vm._v("Elite Status and its exclusive benefits are within reach. ")
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://www.flyfrontier.com/frontiermiles/elite-status-benefits",
            target: "_blank",
            rel: "noopener"
          }
        },
        [_vm._v("LEARN MORE")]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-395f4086", { render: render, staticRenderFns: staticRenderFns })
  }
}